import urls from './urls'
import Service from '@/utils/fetch'

// 获取纪念堂列表
export function _findOrderList(data) {
  return Service({
    url: urls.findOrderList,
    data
  })
}

// 获取商品列表
export function _findProduct(data) {
  return Service({
    url: urls.findProduct,
    data
  })
}


// 获取支付方式列表
export function _findPayType(data) {
  return Service({
    url: urls.findPayType,
    data
  })
}

// 添加订单备注
export function _addRemark(data) {
  return Service({
    url: urls.addRemark,
    data
  })
}

// 订单退款
export function _payRefund(data) {
  return Service({
    url: urls.payRefund,
    data
  })
}

// 获取订单日志列表
export function _findOrderLog(data) {
  return Service({
    url: urls.findOrderLog,
    data
  })
}

// 获取续费纪念堂二维码
export function _getRenewQRCode(data) {
  return Service({
    url: urls.getRenewQRCode,
    data
  })
}

// 获取购买纪念堂二维码
export function _getPurchaseQRCode(data) {
  return Service({
    url: urls.getPurchaseQRCode,
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/Online/index.js